import { render, staticRenderFns } from "./sertificates.vue?vue&type=template&id=12f476b8&scoped=true"
import script from "./sertificates.vue?vue&type=script&lang=ts"
export * from "./sertificates.vue?vue&type=script&lang=ts"
import style0 from "./sertificates.vue?vue&type=style&index=0&id=12f476b8&prod&lang=css&scoped=true"
import style1 from "./sertificates.vue?vue&type=style&index=1&id=12f476b8&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12f476b8",
  null
  
)

export default component.exports